import React, { useEffect, useState } from "react";
import Container from "../../components/Container";
import { connect } from "react-redux";
import { logIn, fetch } from "../../actions/index";
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import SelectFabricantes from "../../components/SelectFabricantes";
import SelectFiltros from "../../components/SelectFiltros";
import SelectLojas from "../../components/SelectLojas";
import { useFetch } from './../../components/Hooks/Conexao';
import { LoadingScreenBlank } from './../../components/Diversos';
import HeaderHiddenMenu from "../Menu/HeaderHiddenMenu";

function Func(props) {
    const reportId = props.reportId;

    const [token, listarToken, loadingToken] = useFetch(() => props.fetch().post("/outros/getpowerbitoken"));
    const [filtros, setFiltros] = useState({});
    const filterCnpj = props.pesq?.empresa?.filter(x => !!x.cnpj)?.map(x => x.cnpj?.trim());

    const loading = !filterCnpj || !filterCnpj.length || !token;


    let cnpj = {
        $schema: "http://powerbi.com/product/schema#basic",
        target: {
            table: "analise (Matconlab)",
            column: "Cnpj"
        },
        operator: "In",
        values: filterCnpj
    };

    useEffect(() => {
        listarToken()
    }, [])

    if (loading) {
        return <>
            {loading && <LoadingScreenBlank loading={loading} />}
            <div style={{ display: 'none' }}>
                <SelectLojas value={filtros.lojas} setValue={v => setFiltros(state => { return { ...state, lojas: v } })} />
            </div>
        </>
    }



    return (
        <div style={{ position: 'relative' }}>
            <HeaderHiddenMenu />
            <div>
                {!loading && <div>
                    <PowerBIEmbed
                        embedConfig={{
                            type: 'report',   // Supported types: report, dashboard, tile, visual and qna
                            id: reportId,
                            embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}`,
                            accessToken: token,
                            tokenType: models.TokenType.Aad,
                            //filters: [fab, set, gru, cnpj],
                            filters: [cnpj],
                            pageName: PowerBIEmbed.pageName,
                            settings:
                            {
                                panes:
                                {
                                    filters:
                                    {
                                        expanded: false,
                                        visible: false
                                    },
                                    pageNavigation: {
                                        visible: false
                                    }

                                }
                            },
                        }}

                        eventHandlers={
                            new Map([
                                ['loaded', function () { console.log('Report loaded'); }],
                                ['rendered', function () { console.log('Report rendered'); }],
                                ['error', function (event) { console.log(event.detail); }]
                            ])
                        }

                        cssClassName={"powerbi-container"}

                        getEmbeddedComponent={(embeddedReport) => {
                            window.report = embeddedReport;
                        }}
                    />
                </div>}

            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return { pesq: state.pesq };
};
const PowerBiRep = connect(mapStateToProps, { logIn, fetch })(Func);

export function PowerBiGestaoCat(props) {
    return <PowerBiRep reportId='99bf54b0-5f61-476f-959f-fbcb926f12ab' />
}

export function PowerBiPricing(props) {
    return <PowerBiRep reportId="4e9213d0-b1a9-4ca2-ae3a-105d8ed862b2" />
}